module.exports = __webpack_public_path__ + "img/p2-47.9092a0fb.png";